define([
	"dojo/_base/declare",
	"csi/heading/EnumAction",
	"csi/sessionConstants",
	"csi/xml"
], function(declare,EnumAction,sessionConstants,xml) {

	return declare(EnumAction, {
		_getRenderAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: disable action if node is frozen or logged-in user is not task user
			var	task = ctx.getNode();
			if (xml.nodeHasFlag(task, xml.NODE_FLAG_FROZEN))
				return null;

			if (sessionConstants.userUrl != task?.User)
				return null;

			var wbsElement = ctx.cache.getPathNode(ctx.getNode(), "Child:__Parent__/Child:__Parent__/Child:__Parent__"); // the task

			if (wbsElement && wbsElement.WEState == "WbsElement.State:Complete") {
				return null;
			}

			return this.inherited(arguments);
		}
	});
});